import { useEffect, useRef } from "react";

const SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY;
const SRC = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
let loading = null;
const load = () => {
  if (window.turnstile) return Promise.resolve();
  if (!loading) loading = new Promise((res, rej) => { const s = document.createElement("script"); s.src = SRC; s.async = true; s.onload = res; s.onerror = rej; document.head.appendChild(s); });
  return loading;
};

export const turnstileEnabled = () => !!SITE_KEY;

/* Cloudflare Turnstile widget (explicit render). Calls onToken(token|"") as the challenge passes/expires. Renders nothing without a site key. */
export const Turnstile = ({ action, onToken, resetKey }) => {
  const ref = useRef(null);
  const id = useRef(null);
  useEffect(() => {
    if (!SITE_KEY) return undefined;
    let gone = false;
    load().then(() => {
      if (gone || !ref.current || !window.turnstile) return;
      id.current = window.turnstile.render(ref.current, {
        sitekey: SITE_KEY, action, theme: "light", appearance: "interaction-only",
        callback: (t) => onToken(t), "expired-callback": () => onToken(""), "error-callback": () => onToken(""), "timeout-callback": () => onToken(""),
      });
    }).catch(() => onToken(""));
    return () => { gone = true; if (id.current != null && window.turnstile) { window.turnstile.remove(id.current); id.current = null; } };
  }, [action, resetKey]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!SITE_KEY) return null;
  return <div ref={ref} data-testid="turnstile-widget" aria-label="Bot check" />;
};
